import { useState } from "react";
import { useRecentCorrections } from "../hooks/useOcrHealthData";
import { SOURCE_COLORS } from "../sourceColors";
import styles from "../ocr-health.module.css";
import { PanelCard, PanelError, PanelStatus } from "./PanelCard";

export function RecentCorrectionsStream() {
  const { data, isLoading, error } = useRecentCorrections(20);
  const [openDiag, setOpenDiag] = useState<number | null>(null);

  return (
    <PanelCard title="Recent Corrections (last 20)">
      {isLoading && <PanelStatus>Loading…</PanelStatus>}
      {error && <PanelError>Couldn't load — {error}</PanelError>}
      {data && data.corrections.length === 0 && <PanelStatus>No corrections yet</PanelStatus>}
      {data && data.corrections.length > 0 && (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Time</th>
              <th>Document</th>
              <th>Field</th>
              <th>OCR → Keyed</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {data.corrections.map((c, i) => (
              <tr
                key={i}
                className={styles.tableRowRelative}
                onMouseEnter={() => c.ocrSource === "InkDensity" && c.inkDensityDiag && setOpenDiag(i)}
                onMouseLeave={() => setOpenDiag(null)}
              >
                <td>{new Date(c.correctedAt).toLocaleTimeString()}</td>
                <td>{c.documentDisplayId ?? "—"}</td>
                <td>{c.fieldName}</td>
                <td className={styles.diff}>
                  <span className={styles.diffOld}>{c.ocrValue ?? "∅"}</span>
                  <span className={styles.diffNew}>{c.keyedValue ?? "∅"}</span>
                </td>
                <td>
                  <span
                    className={styles.sourceBadge}
                    style={{ color: SOURCE_COLORS[c.ocrSource ?? "Legacy"] }}
                  >
                    {c.ocrSource ?? "Legacy"}
                  </span>
                  {openDiag === i && c.inkDensityDiag && (
                    <div className={styles.diagPopover}>
                      {JSON.stringify(c.inkDensityDiag, null, 2)}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </PanelCard>
  );
}
